import "./BottomNav.css";

function BottomNav({ setPage, currentPage }) {

  /* ================= ROW 1 ================= */

  const row1 = [

    { page: "MarineTerminal", name: "Marine Import" },
    { page: "PipelineReceiving", name: "Pipeline Import" },
    { page: "TruckOffloading", name: "Truck Offloading" },

    { page: "CrudeTank1", name: "Crude Tank 1" },
    { page: "CrudeTank2", name: "Crude Tank 2" },

    { page: "BlendingSystem", name: "Blending" },
    { page: "DayTank", name: "Day Tanks" },

    { page: "SlopTank", name: "Slop Tank" },

    { page: "PigLauncher", name: "Pig Launcher" },
    { page: "PigReceiver", name: "Pig Receiver" },

    { page: "PreHeatTrain1", name: "Preheat Train 1" },
    { page: "PreHeatTrain2", name: "Preheat Train 2" },

    { page: "Desalter1", name: "Desalter1" },

  ];

  /* ================= ROW 2 ================= */

  const row2 = [
     { page: "Desalter2", name: "Desalter2" },

    { page: "PostDesalterHEX1", name: "Post-Desalter HEX 1" },

    { page: "PostDesalterHEX2", name: "Post-Desalter HEX 2" },

    { page: "PreFlashTower", name: "Pre-Flash Tower" },

    { page: "PFRefluxCond1", name: "P-F Reflux Cond1" },
    
    { page: "PFRefluxCond2", name: "P-F Reflux Cond2" },

    { page: "FurnacePreHeat", name: "Furnace Preheat" },
    
    { page: "Furnace", name: "Furnace (F-101)" },

    { page: "MainFractionationTowers", name: "TopFrac" },

    { page: "MainFractionationTowers2", name: "BottomFrac" },

    { page: "ProductStripper", name: "Stripper" },

    { page: "T102RefluxCond", name: "T-102 Reflux Cond" },

    { page: "NaphthaReflux", name: " T-102 Naphtha Reflux" },

    { page: "SurgeTank", name: "Surge Tank" },

    { page: "StabilizationTower", name: "Stabilizer" },

    { page: "StabilizationReflux", name: "Stab Reflux" },

    { page: "CorrosionDosing", name: "Corrosion Dosing" },

    { page: "FuelGasSystem", name: "Fuel Gas" },

    { page: "DieselCooler", name: "Diesel Cooler" },

    { page: "Residue", name: "Residue" },

    { page: "Naphtha", name: "Naphtha" },

    { page: "LPG", name: "LPG" },

    { page: "Diesel", name: "Diesel" },

    { page: "Kerosene", name: "Kerosene" },

    { page: "LoadingGantry", name: "Loading Gantry" },

    { page: "Desalination", name: "Desalination" },
    
    { page: "Flare", name: "Flare" },

    { page: "EconometricDashboard", name: "NKRBIC" },

  ];

  /* ================= RENDER ROW ================= */

  const renderRow = (row) => (

    <div className="nav-row">

      {row.map((item) => (

        <button
          key={item.page}

          onClick={() => setPage(item.page)}

          className={
            currentPage === item.page
              ? "nav-link active"
              : "nav-link"
          }
        >
          {item.name}
        </button>

      ))}

    </div>

  );

  return (

    <div className="bottom-nav">

      {renderRow(row1)}

      {renderRow(row2)}

    </div>

  );

}

export default BottomNav;